import React, { ChangeEvent, memo } from 'react'
import { Miles } from 'apps/fleet-planner/components/load-details/Details'
import { LockedTooltip } from 'apps/fleet-planner/components/load-details/LockedTooltip'
import { LOAD_FIELDS } from 'apps/fleet-planner/utils/permissions'
import { TextInput } from 'components/atoms'
import { Button, Card, InlineEditContainer } from 'transfix-ui'

interface MilesInlineEditProps {
  miles?: string
  currentEditField?: string
  onEditModeRequested: (name?: string) => void
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  onSave: () => void
  onCancel: () => void
  isLocked?: boolean
  isLoading?: boolean
}

export const MilesInlineEdit = memo<MilesInlineEditProps>(
  ({
    currentEditField,
    isLoading,
    isLocked,
    miles,
    onCancel,
    onChange,
    onEditModeRequested,
    onSave,
  }) => {
    const formattedMiles = miles ? parseInt(miles, 10) : ''
    const NAME = LOAD_FIELDS.miles
    const isEditMode = currentEditField === NAME

    return (
      <InlineEditContainer
        isLoading={isLoading}
        isLocked={isLocked}
        lockedIcon={<LockedTooltip className='locked-icon' />}
        dataTest='load-details-miles-section'
        name={NAME}
        editModeEnabled={isEditMode}
        onEditModeRequested={onEditModeRequested}
        resetOnClickOutside={false}
        editMode={
          <Card className='pa4'>
            <TextInput
              placeholder='0000'
              label='Miles'
              type='number'
              clearable={false}
              value={formattedMiles || ''}
              onChange={onChange}
              dataTest='inline-edit-miles'
              large
            />
            <div className='tr'>
              <div className='mt4'>
                <Button
                  color='tertiary'
                  size='large'
                  onClick={onCancel}
                  data-test='load-miles-cancel'>
                  Cancel
                </Button>
                <Button color='primary' size='large' onClick={onSave} data-test='load-miles-submit'>
                  Save
                </Button>
              </div>
            </div>
          </Card>
        }>
        <Miles miles={formattedMiles} />
      </InlineEditContainer>
    )
  }
)
